import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { PromoTemplates } from "./PromoTemplates";

export const PromoToolbar = ({ 
  tempSettings,
  setTempSettings,
  template, 
  setTemplate, 
  handlePrintPromos,
  handleSavePromoChanges
}) => {
  return (
    <Row>
    <Col lg={6} xs={3}>
      <div>
        <Row className="mb-2">
          <Col className="text-start d-flex justify-content-start align-items-center">
            <span style={{
              minWidth: '100px'
            }}>Promo ID:&nbsp;</span>
            <Form.Control
              type="text"
              value={tempSettings.promoId}
              onChange={(e) => setTempSettings({...tempSettings, promoId: e.target.value})}
              style={{ maxWidth: '200px' }}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col className="text-start d-flex justify-content-start align-items-center">
            <span style={{
              minWidth: '100px'
            }}>Name:&nbsp;</span>
            <Form.Control
              type="text"
              value={tempSettings.name}
              onChange={(e) => setTempSettings({...tempSettings, name: e.target.value})}
              style={{ maxWidth: '300px' }}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col className="text-start d-flex justify-content-start align-items-center">
            <span style={{
              minWidth: '100px'
            }}>Start Date:&nbsp;</span>
            <Form.Control
              type="date"
              value={tempSettings.startDate}
              onChange={(e) => setTempSettings({...tempSettings, startDate: e.target.value})}
              style={{ maxWidth: '200px' }}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col className="text-start d-flex justify-content-start align-items-center">
            <span style={{
              minWidth: '100px'
            }}>End Date:&nbsp;</span>
            <Form.Control
              type="date"
              value={tempSettings.endDate}
              onChange={(e) => setTempSettings({...tempSettings, endDate: e.target.value})}
              style={{ maxWidth: '200px' }}
            />
          </Col>
        </Row>
      </div>
    </Col>
    <Col className="text-end d-flex justify-content-end align-items-center">
      <div className="d-flex flex-column align-items-end">
        <div className="d-flex align-items-center mb-2">
          <span style={{ minWidth: '130px', whiteSpace: 'nowrap' }}>Promo Template:&nbsp;</span>
          <Form.Select 
            style={{
              maxWidth: '200px',
              minWidth: '200px'
            }}
            id="template" 
            value={template}
            onChange={(e) => setTemplate(e.target.value)}
          >
            {PromoTemplates.map((templateOption) => (
              <option value={templateOption.value} key={templateOption.name}>
                {templateOption.name}
              </option>
            ))}
          </Form.Select>
        </div>
        <div>
          <Button 
            style={{
              backgroundColor: "#a73c21",
              borderRadius: "0px",
              borderColor: "#a73c21"
            }}
            onClick={handlePrintPromos}
          >
            Print Promos
          </Button>
        </div>
      </div>
    </Col>
  </Row>
  );
};

export const PromoDisplay = ({
    promoId, 
    name, 
    startDate,  
    endDate,
    template, 
    setTemplate, 
    handlePrintPromos 
}) => {
    return (
    <Row>
        <Col lg={6} xs={3}>
            <Row>
                <h2 className="text-start">{promoId}</h2>
            </Row>
            <h4 className="text-start" style={{
                color: '#333'
            }}>{name}</h4>
              
            <div className="text-start text-muted">
                <span>From: {startDate}</span>
                <span> &nbsp;•&nbsp; </span>
                <span>To: {endDate}</span>
            </div>
        </Col>
        <Col className="text-end d-flex justify-content-end align-items-center">
        <div className="d-flex flex-column align-items-end">
            <div className="d-flex align-items-center mb-4">
                <span style={{ minWidth: '130px', whiteSpace: 'nowrap' }}>Promo Template:&nbsp;</span>
                <Form.Select 
                    style={{
                        maxWidth: '200px',
                        minWidth: '200px'
                    }}
                    id="template" onChange={(e) => setTemplate(e.target.value)}>
                    {PromoTemplates.map((templateOption) => <option value={templateOption.value} key={templateOption.name}>{templateOption.name}</option>)}
                </Form.Select>
            </div>
            <div style={{
                //marginRight: '210px'
            }}>
                <Button style={{
                    backgroundColor: "#a73c21",
                    borderRadius: "0px",
                    borderColor: "#a73c21"}}
                    onClick={() => handlePrintPromos()}
                >Print Promos</Button>
            </div>
        </div>
        </Col>
    </Row>
    )
}